import ICommand from "./ICommand";
import {useAppDispatch, useAppSelector} from "../hooks";
import {selectLogEntries} from "../redux/logs";
import {setCurrentLog, setLogEditor} from "../redux/ui";
import {formatDate} from "../format/DateFormat";

export const useViCommand = (): ICommand => {
  const logs = useAppSelector(selectLogEntries)
  const dispatch = useAppDispatch()

  return {
    secure: true,

    help(): string {
      return '- vi [NUMBER?]\t\t\t\t:: opens the journal entry with the specified number or creates a new entry';
    },

    async process(msg: string): Promise<void> {
      const command = msg.toLowerCase().trim()
      let index: number|null = null
      if (command.startsWith('vi ')) {
        index = parseInt(command.substring('vi '.length))
      }

      if (index !== null) {
        //editing
        dispatch(setCurrentLog(logs[index] || null))
      } else {
        const date = new Date()
        const dateString = formatDate(date)
        //creating
        dispatch(setCurrentLog({
          entry: `# Title
*${dateString}*

`
        }))
      }

      dispatch(setLogEditor(true))
    },

    matches(msg: string): boolean {
      const viMatch = msg.toLowerCase().trim().match(new RegExp('vi( [0-9]+)?'))
      return Boolean(viMatch && viMatch.length > 0)
    }
  };
}